module.exports = __webpack_public_path__ + "static/img/img-logo-hili.2c25320.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-logo-hili.jpg
// module id = r8Tg
// module chunks = 2